/* ============================================================
   BGC — bgc-biz.js
   For Business page sections: bgc-oem, bgc-sig (signature toggle),
   bgc-reach. Owned by AGENT-BIZ.
   IIFE, guards on element existence, GSAP+ScrollTrigger used when
   present (loaded globally by theme.liquid), CSS/IO fallback
   otherwise. Supports multiple section instances on a page.
   ============================================================ */

(function () {
  "use strict";

  var reduced = document.documentElement.classList.contains("reduced");

  /* ---------- OEM: brand showcase stage — chip crossfade + auto-cycle ---------- */
  var OEM_AUTOPLAY_MS = 4000;

  function hexToRgba(hex, alpha) {
    if (!hex) return null;
    hex = hex.trim().replace("#", "");
    if (hex.length === 3) {
      hex = hex.split("").map(function (c) { return c + c; }).join("");
    }
    if (hex.length !== 6) return null;
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    if (isNaN(r) || isNaN(g) || isNaN(b)) return null;
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  }

  function initOemShowcase() {
    var stages = document.querySelectorAll("[data-bgc-oem-stage]");
    if (!stages.length) return;

    stages.forEach(function (root) {
      var chips = root.querySelectorAll(".bgc-oem-chip");
      var imgs = root.querySelectorAll("[data-bgc-oem-img]");
      var overlay = root.querySelector("[data-bgc-oem-overlay]");
      var halo = root.querySelector("[data-bgc-oem-halo]");
      var label = root.querySelector("[data-bgc-oem-label]");
      if (!chips.length || !imgs.length) return;

      var keys = Array.prototype.map.call(chips, function (c) {
        return c.getAttribute("data-bgc-oem-key");
      });
      var idx = 0;
      var timer = null;

      function applyKey(key) {
        imgs.forEach(function (im) {
          im.classList.toggle("on", im.getAttribute("data-bgc-oem-img") === key);
        });

        var activeChip = null;
        chips.forEach(function (c) {
          var isOn = c.getAttribute("data-bgc-oem-key") === key;
          c.classList.toggle("on", isOn);
          c.setAttribute("aria-pressed", isOn ? "true" : "false");
          if (isOn) activeChip = c;
        });

        if (overlay) overlay.classList.toggle("on", key === "your-brand");

        if (halo) {
          var accent = activeChip ? activeChip.style.getPropertyValue("--accent") : "";
          var haloColor = key === "your-brand" ? "rgba(236,126,28,0.22)" : hexToRgba(accent, 0.18);
          halo.style.setProperty("--halo", haloColor || "rgba(236,126,28,0.18)");
        }

        if (label) {
          label.textContent = activeChip ? activeChip.getAttribute("data-bgc-oem-name") : "";
        }
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      function goTo(i) {
        idx = ((i % keys.length) + keys.length) % keys.length;
        applyKey(keys[idx]);
      }

      chips.forEach(function (chip, i) {
        chip.addEventListener("click", function () {
          stopAutoplay();
          if (chip.classList.contains("on")) return;
          goTo(i);
        });
      });

      if (!reduced && keys.length > 1) {
        timer = setInterval(function () {
          goTo(idx + 1);
        }, OEM_AUTOPLAY_MS);
      }
    });
  }

  /* ---------- Signature toggle: pills crossfade image + content block ---------- */
  function initSigToggle() {
    var stages = document.querySelectorAll("[data-bgc-sig-stage]");
    if (!stages.length) return;

    stages.forEach(function (stage) {
      var toggles = stage.querySelectorAll(".bgc-sig-toggle");
      var imgs = stage.querySelectorAll("[data-bgc-sig-img]");
      var contents = stage.querySelectorAll("[data-bgc-sig-content]");
      var halo = stage.querySelector("[data-bgc-sig-halo]");
      if (!toggles.length) return;

      function applyKey(key, haloVal) {
        imgs.forEach(function (im) {
          im.classList.toggle("on", im.getAttribute("data-bgc-sig-img") === key);
        });
        contents.forEach(function (c) {
          c.classList.toggle("on", c.getAttribute("data-bgc-sig-content") === key);
        });
        if (halo && haloVal) halo.style.setProperty("--halo", haloVal);
      }

      toggles.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.classList.contains("on")) return;
          toggles.forEach(function (b) { b.classList.remove("on"); });
          btn.classList.add("on");
          applyKey(btn.getAttribute("data-bgc-sig-key"), btn.getAttribute("data-halo"));
        });
      });
    });
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  ready(function () {
    initOemShowcase();
    initSigToggle();
  });
})();

/* smooth-scroll fallback for [data-bgc-scrollto] links (used by the OEM CTA
   band — JSON-template section ids are generated, so anchors can't be
   hand-written). Only intercepts when the href is left as "#". */
(function () {
  "use strict";
  document.addEventListener("click", function (evt) {
    var link = evt.target.closest("[data-bgc-scrollto]");
    if (!link) return;
    if ((link.getAttribute("href") || "") !== "#") return;
    var target = document.querySelector(link.getAttribute("data-bgc-scrollto"));
    if (!target) return;
    evt.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();
